/* ALT bundle PDP: accordion picker behaviour.
   Built as bundle PDP redesign part 2 (see snippets/product-bundle-components.liquid,
   commit a229b27, for the markup this drives).

   Engine-agnostic on purpose: everything here keys off the
   .product__bundle-components / bundle-component / .alt-bundle-tile__*
   classes and data-* attributes, never the <product-bundle> custom element,
   so it keeps working unchanged when a later unit swaps that wrapper for
   <alt-bundle-product>.

   Frozen files this script reads but never edits: assets/custom.js
   (ProductBundle drives the size-radio click handler, data-selected-variant-id,
   the form submit/add-to-cart, and ProductPersonalization's validate()/
   resetFields()) and assets/product.js (the #cart-bar sticky bar, minified).
   Both keep working unmodified; this script only adds behaviour around them.
*/
(function () {
  'use strict';

  var HEAD_SELECTOR = '.alt-bundle-tile__head';
  var PANEL_SELECTOR = '.alt-bundle-tile__panel';

  function tileIndex(tile) {
    return parseInt(tile.getAttribute('data-index'), 10);
  }

  function isInteractiveTile(tile) {
    // Type 3 ("Included") tiles have a static head and no panel; every
    // other type (1, 2, 4) is a real accordion tile.
    return tile.getAttribute('data-tile-type') !== '3';
  }

  function headOf(tile) {
    return tile.querySelector(HEAD_SELECTOR);
  }

  function panelOf(tile) {
    return tile.querySelector(PANEL_SELECTOR);
  }

  function isRealHead(head) {
    // The type-3 static row also carries the .alt-bundle-tile__head class
    // (plus --static) but is a plain div with no aria-expanded/aria-controls.
    // Never treat it as an accordion head: never open it, never focus it.
    return !!head && head.hasAttribute('aria-expanded');
  }

  var STATUS_SIZE_SELECTOR = '[data-alt-status-size]';
  var STATUS_PERSONALIZATION_SELECTOR = '[data-alt-status-personalization]';

  // Engine-agnostic (bundle PDP redesign, B3/B6/B7): a legacy tile carries <product-personalization>,
  // an alt tile carries <native-personalizer>. Checked in that order and only one exists per tile
  // (the engine is a whole-bundle setting, snippets/product-bundle-components.liquid), so there is
  // no ambiguity between the two checks.
  function isPersonalized(tile) {
    var personalization = tile.querySelector('product-personalization');
    if (personalization) {
      var toggle = personalization.querySelector('[data-action="add-remove"]');
      var optedIn = !!toggle && toggle.value !== 'false';
      if (!optedIn) return false;

      var textInputs = personalization.querySelectorAll('input[type="text"]');
      for (var i = 0; i < textInputs.length; i++) {
        if (textInputs[i].value.trim() !== '') return true;
      }
      return false;
    }

    var nativePersonalizer = tile.querySelector('native-personalizer');
    if (nativePersonalizer && typeof nativePersonalizer.getConfirmedProperties === 'function') {
      // Mid re-edit (pencil, or a cart edit) getConfirmedProperties() deliberately returns {},
      // but the tile IS still personalized: the confirmed panel stays shown until she confirms or
      // removes. Read that instead of flashing "+ Add personalization" (code review, 2026-09-25).
      if (typeof nativePersonalizer.isEditing === 'function' && nativePersonalizer.isEditing()) {
        return !!(nativePersonalizer.panel && !nativePersonalizer.panel.hidden);
      }
      var confirmed = nativePersonalizer.getConfirmedProperties();
      return !!confirmed && Object.keys(confirmed).length > 0;
    }

    return false;
  }

  // Per-tile status items in the head: "Size needed" / "Size M" (attention
  // vs done) and "+ Add personalization" / "Personalized" (invitation vs
  // done, never styled as a warning). Replaces the old single-line summary.
  function updateStatus(tile, strings) {
    var tileType = tile.getAttribute('data-tile-type');

    if (tileType === '1' || tileType === '4') {
      var sizeItem = tile.querySelector(STATUS_SIZE_SELECTOR);
      if (sizeItem) {
        var sizeTextEl = sizeItem.querySelector('[data-alt-status-size-text]');
        var checked = tile.querySelector('[data-single-option-selector]:checked');
        if (checked) {
          sizeItem.classList.add('is-done');
          if (sizeTextEl) sizeTextEl.textContent = strings.sizeSelected.replace('%SIZE%', checked.value);
        } else {
          sizeItem.classList.remove('is-done');
          if (sizeTextEl) sizeTextEl.textContent = strings.sizeNeeded;
        }
      }
    }

    if (tileType === '1' || tileType === '2') {
      var personalizationItem = tile.querySelector(STATUS_PERSONALIZATION_SELECTOR);
      if (personalizationItem) {
        var pTextEl = personalizationItem.querySelector('[data-alt-status-personalization-text]');
        if (isPersonalized(tile)) {
          personalizationItem.classList.add('is-done');
          if (pTextEl) pTextEl.textContent = strings.personalized;
        } else {
          personalizationItem.classList.remove('is-done');
          if (pTextEl) pTextEl.textContent = strings.addPersonalization;
        }
      }
    }
  }

  // Interactive tiles (types 1/4) still needing a size, in this container.
  function countMissingSizes(interactiveTiles) {
    var count = 0;
    interactiveTiles.forEach(function (tile) {
      var tileType = tile.getAttribute('data-tile-type');
      if (tileType === '1' || tileType === '4') {
        if (!tile.querySelector('[data-single-option-selector]:checked')) count++;
      }
    });
    return count;
  }

  // Shared by the Add-to-bag button, the sticky cart-bar button, and the
  // aria-live announcement: same message, same "leave it alone once
  // disabled/sold-out" rule.
  function setGuidedButtonText(el, message) {
    if (!el) return;
    var btn = el.tagName === 'BUTTON' ? el : el.closest('button');
    if (btn && btn.hasAttribute('data-alt-sold-out')) return; // never touch a sold-out button

    if (!el.hasAttribute('data-alt-original-text')) {
      el.setAttribute('data-alt-original-text', el.textContent);
    }

    var next = message || el.getAttribute('data-alt-original-text');
    if (el.textContent !== next) el.textContent = next;
  }

  function findCartBarTextEl() {
    return (
      document.querySelector('#cart-bar [data-add-to-cart-bar] [data-add-to-cart-text]') ||
      document.querySelector('#cart-bar [data-add-to-cart-bar] .btn__text')
    );
  }

  function updateBundleCountUI(form, interactiveTiles, strings, liveRegion) {
    if (!form) return;

    var missing = countMissingSizes(interactiveTiles);
    var message =
      missing > 0
        ? missing === 1
          ? strings.chooseSizeSingular
          : strings.chooseSizePlural.replace('%COUNT%', missing)
        : '';

    var submitBtn = form.querySelector('.product__bundle-submit');

    // Sold-out bundle (the submit renders disabled): the sticky cart bar must say the same thing
    // as the main button, not "Choose N more sizes" (found on Deluxe Blue, Helene Top sold out,
    // 2026-09-25). Mirror the main button's own text onto the bar and disable the bar button,
    // and announce nothing about sizes, since no size choice can make the bundle buyable.
    // Sold out is the server-rendered marker, never bare .disabled: alt-bundle.js disables the
    // button while an add is in flight, and reading that as sold out stuck the sticky bar on
    // "Sold Out" (code review, 2026-09-25).
    if (submitBtn && submitBtn.hasAttribute('data-alt-sold-out')) {
      var barText = findCartBarTextEl();
      if (barText) {
        if (!barText.hasAttribute('data-alt-original-text')) barText.setAttribute('data-alt-original-text', barText.textContent);
        var label = strings.soldOut || barText.getAttribute('data-alt-original-text');
        if (barText.textContent !== label) barText.textContent = label;
        var barBtn = barText.closest('button');
        if (barBtn) barBtn.disabled = true;
      }
      if (liveRegion && liveRegion.textContent !== '') liveRegion.textContent = '';
      return;
    }

    setGuidedButtonText(submitBtn, message);
    setGuidedButtonText(findCartBarTextEl(), message);

    if (liveRegion && liveRegion.textContent !== message) {
      liveRegion.textContent = message;
    }
  }

  function setupContainer(container) {
    if (container.hasAttribute('data-alt-picker')) return; // already initialized

    var tiles = Array.prototype.slice.call(container.querySelectorAll('bundle-component'));
    var interactiveTiles = tiles.filter(isInteractiveTile);
    if (interactiveTiles.length === 0) return; // rule 1: nothing to do

    var strings = {
      sizeNeeded: container.dataset.altSizeNeededText || 'Size needed',
      sizeSelected: container.dataset.altSizeSelectedText || 'Size %SIZE%',
      addPersonalization: container.dataset.altAddPersonalizationText || '+ Add personalization',
      personalized: container.dataset.altPersonalizedText || 'Personalized',
      nextItem: container.dataset.altNextText || 'Next: %TITLE%',
      chooseSizeSingular: container.dataset.altChooseSizeSingularText || 'Choose 1 more size',
      chooseSizePlural: container.dataset.altChooseSizePluralText || 'Choose %COUNT% more sizes',
      soldOut: container.dataset.altSoldOutText || 'Sold Out'
    };

    var form = container.closest('form');
    var liveRegion = container.querySelector('[data-alt-bundle-live]');

    // Shared by guided advance (rule 7) and the Next button (rule 8): open a
    // tile the shopper didn't directly click (unlike a head click, where the
    // clicked element already has focus), so move focus there deliberately.
    function openInteractiveTile(tile) {
      setOpenIndex(tileIndex(tile));
      var head = headOf(tile);
      if (head) {
        head.focus();
        head.scrollIntoView({ block: 'nearest' });
      }
    }

    // Forward search with wraparound for the next interactive tile (type 1
    // or 4) that still needs a size, starting after fromTile. Stops and
    // returns null once it's back around to fromTile itself.
    function findNextTileNeedingSize(fromTile) {
      var idx = interactiveTiles.indexOf(fromTile);
      if (idx === -1) return null;

      for (var i = 1; i <= interactiveTiles.length; i++) {
        var candidate = interactiveTiles[(idx + i) % interactiveTiles.length];
        if (candidate === fromTile) break;
        var tType = candidate.getAttribute('data-tile-type');
        if ((tType === '1' || tType === '4') && !candidate.querySelector('[data-single-option-selector]:checked')) {
          return candidate;
        }
      }
      return null;
    }

    var openIndex = parseInt(container.getAttribute('data-open-index'), 10);
    var openMatch = null;
    interactiveTiles.forEach(function (tile) {
      if (tileIndex(tile) === openIndex) openMatch = tile;
    });
    if (!openMatch) {
      // data-open-index didn't land on an interactive tile (e.g. tile 0 is a
      // static type-3 row): default to the first interactive tile instead.
      openIndex = tileIndex(interactiveTiles[0]);
    }

    function applyState() {
      container.setAttribute('data-open-index', String(openIndex));
      interactiveTiles.forEach(function (tile) {
        var isOpen = tileIndex(tile) === openIndex;
        var head = headOf(tile);
        var panel = panelOf(tile);
        if (head) head.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        if (panel) {
          if (isOpen) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
        }
      });
    }

    // Returns true only if this actually changed which tile is open.
    function setOpenIndex(idx) {
      if (idx === openIndex) return false;
      openIndex = idx;
      applyState();
      return true;
    }

    applyState();
    interactiveTiles.forEach(function (tile) {
      updateStatus(tile, strings);
    });
    updateBundleCountUI(form, interactiveTiles, strings, liveRegion);
    container.setAttribute('data-alt-picker', 'ready');

    // --- Rule 7: Next buttons (guided advance, manual) ---
    // Every interactive tile except the last gets one, wired to the next
    // interactive tile in sequence (not "next needing a size": this is a
    // plain forward step, available even once everything is filled in).
    interactiveTiles.forEach(function (tile, i) {
      var nextBtn = tile.querySelector('[data-alt-next-button]');
      if (!nextBtn) return;
      if (i === interactiveTiles.length - 1) return; // last interactive tile: none

      var targetTile = interactiveTiles[i + 1];
      var titleEl = targetTile.querySelector('.alt-bundle-tile__title');
      var targetTitle = titleEl ? titleEl.textContent.trim() : '';
      var textEl = nextBtn.querySelector('[data-alt-next-text]');
      if (textEl) textEl.textContent = strings.nextItem.replace('%TITLE%', targetTitle);

      nextBtn.removeAttribute('hidden');
      nextBtn.addEventListener('click', function () {
        openInteractiveTile(targetTile);
      });
    });

    // --- Rule 8: guided auto-advance ---
    // Only for type 4 (sizes, no personalization): picking a size there is
    // the whole job for that tile, so move on automatically. Types 1/2 keep
    // personalization optional and in view; the Next button (rule 7) is
    // their only forward step.
    container.addEventListener('click', function (e) {
      var radio = e.target.closest ? e.target.closest('[data-single-option-selector]') : null;
      if (!radio) return;
      var tile = radio.closest('bundle-component');
      if (!tile || tile.getAttribute('data-tile-type') !== '4') return;

      setTimeout(function () {
        var nextTile = findNextTileNeedingSize(tile);
        if (nextTile) openInteractiveTile(nextTile);
      }, 350);
    });

    // --- Rule 2: open/close + focus ---
    container.addEventListener('click', function (e) {
      var head = e.target.closest ? e.target.closest(HEAD_SELECTOR) : null;
      if (!isRealHead(head)) return;
      var tile = head.closest('bundle-component');
      if (!tile) return;

      var opened = setOpenIndex(tileIndex(tile));
      head.focus();
      if (opened) {
        head.scrollIntoView({ block: 'nearest' });
      }
      // Clicking the already-open head: setOpenIndex is a no-op above, so
      // this branch never toggles it closed (no zero-open state).
    });

    // --- Rule 3: keyboard nav between heads (moving focus never opens) ---
    container.addEventListener('keydown', function (e) {
      var head = e.target.closest ? e.target.closest(HEAD_SELECTOR) : null;
      if (!isRealHead(head)) return;

      var heads = interactiveTiles.map(headOf).filter(Boolean);
      var pos = heads.indexOf(head);
      if (pos === -1) return;

      var nextPos = null;
      if (e.key === 'ArrowDown') {
        nextPos = (pos + 1) % heads.length;
      } else if (e.key === 'ArrowUp') {
        nextPos = (pos - 1 + heads.length) % heads.length;
      } else if (e.key === 'Home') {
        nextPos = 0;
      } else if (e.key === 'End') {
        nextPos = heads.length - 1;
      } else {
        return;
      }

      e.preventDefault();
      heads[nextPos].focus();
    });

    // --- Rule 4: keep each head's status current, and the guidance
    // (Add-to-bag text, cart-bar mirror, live-region count) with it ---
    ['change', 'input', 'click'].forEach(function (evtName) {
      container.addEventListener(evtName, function (e) {
        var panel = e.target.closest ? e.target.closest(PANEL_SELECTOR) : null;
        if (!panel) return;
        var tile = panel.closest('bundle-component');
        if (!tile) return;
        updateStatus(tile, strings);
        updateBundleCountUI(form, interactiveTiles, strings, liveRegion);
      });
    });

    // --- Rule 4b: native-personalizer CANCEL status refresh (alt engine only) ---
    // Rule 4 above already re-runs updateStatus/updateBundleCountUI on every click inside a panel,
    // but native-personalizer.js's cancel flow is not synchronous: closing the drawer with nothing
    // newly confirmed goes through the drawer's ~250-400ms slide-closed exit animation (see
    // native-personalizer.js's ALT-DRAWER region) before `panel.hidden` and `isEditing()` settle
    // into their final state. Reading getConfirmedProperties() at click time (Rule 4's immediate
    // pass) can therefore observe a still-closing drawer and report stale status. Scoped to Cancel
    // ONLY (finding #4 moved confirm/remove to Rule 4c below, which needs no such delay): Cancel
    // has no equivalent np:bundle-* event, since it never calls confirmDrawer()/
    // removePersonalization(). Deliberately calls only updateStatus/updateBundleCountUI, exactly
    // like Rule 4 — never setOpenIndex or any other navigation: cancelling a personalization must
    // never auto-advance to another tile or close the tile the shopper is looking at (operator
    // requirement, 2026-09-24).
    container.addEventListener('click', function (e) {
      var actionEl = e.target.closest ? e.target.closest('[data-np-drawer-cancel]') : null;
      if (!actionEl) return;
      var tile = actionEl.closest('bundle-component');
      if (!tile) return;

      setTimeout(function () {
        updateStatus(tile, strings);
        updateBundleCountUI(form, interactiveTiles, strings, liveRegion);
      }, 300);
    });

    // --- Rule 4c: native-personalizer confirm/remove status refresh via events (alt engine only,
    // finding #4) ---
    // np:bundle-confirmed / np:bundle-removed are dispatched by native-personalizer.js's
    // confirmDrawer()/removePersonalization() (bundle mode only) at the point state has ALREADY
    // settled (panel.hidden, lastConfirmed) — before the drawer's exit animation even starts — so
    // (unlike Rule 4b above) this needs no setTimeout margin. This also catches a Confirm
    // triggered by the Enter key, which calls confirmDrawer() directly and never clicks
    // [data-np-drawer-confirm], so a click-only listener always missed it (same gap finding #4
    // fixes in alt-bundle.js's own save trigger).
    container.addEventListener('np:bundle-confirmed', function (e) {
      var tile = e.target.closest ? e.target.closest('bundle-component') : null;
      if (!tile) return;
      updateStatus(tile, strings);
      updateBundleCountUI(form, interactiveTiles, strings, liveRegion);
    });
    container.addEventListener('np:bundle-removed', function (e) {
      var tile = e.target.closest ? e.target.closest('bundle-component') : null;
      if (!tile) return;
      updateStatus(tile, strings);
      updateBundleCountUI(form, interactiveTiles, strings, liveRegion);
    });
    // Programmatic size sets (alt-bundle.js setTileVariant(), used by the cart-edit prefill) check
    // the radio without any click, so an unpersonalized tile kept a stale "Select size" pill in edit
    // mode even though its size was set (found in the 2026-09-26 cart test).
    container.addEventListener('alt-bundle:variant-change', function (e) {
      var tile = e.target.closest ? e.target.closest('bundle-component') : null;
      if (!tile) return;
      updateStatus(tile, strings);
      updateBundleCountUI(form, interactiveTiles, strings, liveRegion);
    });

    // --- Rule 4d: statuses go stale after a successful add (alt engine only, finding #10) ---
    // alt-bundle.js dispatches `alt-bundle:added` on <alt-bundle-product data-bundle-scope> ITSELF
    // after resetAfterBundleAdd() has already run on every personalizer. That element is an
    // ANCESTOR of this container, not a descendant, so a listener on `container` would never see
    // it: DOM bubbling only reaches a target's ancestors, and this container sits BELOW the
    // dispatch target. Listen on the bundle host instead (found once here): the event and the
    // data-bundle-scope attribute both only exist in alt mode, so under the legacy engine
    // `bundleHost` is simply null and this is a no-op, matching Rule 4b/4c's own alt-only scope.
    var bundleHost = container.closest('[data-bundle-scope]');
    if (bundleHost) {
      bundleHost.addEventListener('alt-bundle:added', function () {
        interactiveTiles.forEach(function (tile) {
          updateStatus(tile, strings);
        });
        updateBundleCountUI(form, interactiveTiles, strings, liveRegion);
      });
    }

    // --- Rule 5: submit reveal ---
    if (form) {
      var submitBtn = form.querySelector('.product__bundle-submit');

      var firstInvalidTile = function () {
        var invalid = form.querySelector(':invalid');
        if (!invalid) return null;
        return invalid.closest('bundle-component');
      };

      var firstPersonalizationGapTile = function () {
        for (var i = 0; i < tiles.length; i++) {
          var personalization = tiles[i].querySelector('product-personalization');
          if (!personalization) continue;
          var toggle = personalization.querySelector('[data-action="add-remove"]');
          if (!toggle || toggle.value === 'false') continue;
          var textInputs = personalization.querySelectorAll('input[type="text"]');
          for (var j = 0; j < textInputs.length; j++) {
            if (textInputs[j].value === '') return tiles[i];
          }
        }
        return null;
      };

      var handleSubmitReveal = function (e) {
        if (!form.checkValidity()) {
          var invalidTile = firstInvalidTile();
          if (invalidTile && isInteractiveTile(invalidTile)) {
            setOpenIndex(tileIndex(invalidTile));
          }
          e.preventDefault();
          e.stopPropagation();
          requestAnimationFrame(function () {
            form.reportValidity();
          });
          return;
        }

        var gapTile = firstPersonalizationGapTile();
        if (gapTile && isInteractiveTile(gapTile)) {
          setOpenIndex(tileIndex(gapTile));
        }
        // Valid (or a personalization gap, but not a native-invalid one):
        // let the click/submit continue so custom.js's onSubmit and
        // product-personalization's own validate() run against the now
        // visible panel.
      };

      if (submitBtn) {
        submitBtn.addEventListener('click', handleSubmitReveal, true);
      }
      form.addEventListener('submit', handleSubmitReveal, true);
    }
  }

  function setupStickyBarRedirect(firstContainer) {
    if (window.__altBundlePickerStickyBarBound) return;
    window.__altBundlePickerStickyBarBound = true;

    var form = firstContainer.closest('form');
    if (!form) return;

    document.addEventListener(
      'click',
      function (e) {
        var barBtn = e.target.closest ? e.target.closest('#cart-bar [data-add-to-cart-bar]') : null;
        if (!barBtn) return;

        // product.js's own handler (attached directly to this button) would
        // do `this.form.querySelector('[data-add-to-cart]')` where `this.form`
        // is the page's [data-product-form]; bundle pages have none, so that
        // throws. Stop it from ever running and redirect to the bundle form.
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();

        form.scrollIntoView({ block: 'center' });

        var submitBtn = form.querySelector('.product__bundle-submit');
        if (submitBtn && !submitBtn.disabled) {
          submitBtn.click();
        }
      },
      true
    );

    // Showing the bar. product.js only toggles #cart-bar's is-visible once the page scrolls past
    // its [data-product-form]; bundle pages have none, so the bar never appeared on any bundle page
    // (live included, found 2026-09-26). Same rule here, measured against the bundle form: visible
    // once its bottom has scrolled above the viewport top. product.js skips its own toggle when it
    // has no form, so nothing fights this.
    var bar = document.querySelector('#cart-bar');
    if (!bar) return;
    var ticking = false;
    function syncBar() {
      ticking = false;
      bar.classList.toggle('is-visible', form.getBoundingClientRect().bottom < 0);
    }
    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(syncBar);
      },
      { passive: true }
    );
    syncBar();
  }

  function init() {
    var containers = Array.prototype.slice.call(document.querySelectorAll('.product__bundle-components'));
    if (containers.length === 0) return; // rule 6: only wire the sticky bar when a bundle exists

    containers.forEach(setupContainer);
    setupStickyBarRedirect(containers[0]);
  }

  init();
})();
